import React from 'react';

const LineChartIcon = ({ size }: { size: number }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height="62"
      fill="none"
      viewBox="0 0 80 56"
    >
      <path stroke="#E5E7EB" strokeWidth="0.8" d="M8 50h68"></path>
      <path stroke="#818CF8" strokeWidth="1.6" d="m8 46 12-12 12 6 12-12 12 6 12-10 8 4"></path>
      <path
        fill="#818CF8"
        d="M8 47.6a1.6 1.6 0 1 0 0-3.2 1.6 1.6 0 0 0 0 3.2M20 35.6a1.6 1.6 0 1 0 0-3.2 1.6 1.6 0 0 0 0 3.2M32 41.6a1.6 1.6 0 1 0 0-3.2 1.6 1.6 0 0 0 0 3.2M44 29.6a1.6 1.6 0 1 0 0-3.2 1.6 1.6 0 0 0 0 3.2M56 35.6a1.6 1.6 0 1 0 0-3.2 1.6 1.6 0 0 0 0 3.2M68 25.6a1.6 1.6 0 1 0 0-3.2 1.6 1.6 0 0 0 0 3.2M76 29.6a1.6 1.6 0 1 0 0-3.2 1.6 1.6 0 0 0 0 3.2"
      ></path>
      <path stroke="#3B82F6" strokeWidth="1.6" d="m8 38 12-16 12 6 12-14 12 6 12-10 8 4"></path>
      <path
        fill="#3B82F6"
        d="M8 39.6a1.6 1.6 0 1 0 0-3.2 1.6 1.6 0 0 0 0 3.2M20 23.6a1.6 1.6 0 1 0 0-3.2 1.6 1.6 0 0 0 0 3.2M32 29.6a1.6 1.6 0 1 0 0-3.2 1.6 1.6 0 0 0 0 3.2M44 15.6a1.6 1.6 0 1 0 0-3.2 1.6 1.6 0 0 0 0 3.2M56 21.6a1.6 1.6 0 1 0 0-3.2 1.6 1.6 0 0 0 0 3.2M68 11.6a1.6 1.6 0 1 0 0-3.2 1.6 1.6 0 0 0 0 3.2M76 15.6a1.6 1.6 0 1 0 0-3.2 1.6 1.6 0 0 0 0 3.2"
      ></path>
    </svg>
  );
};

export default LineChartIcon;
